// @flow strict
// schema.org structure for address can be found here:
// https://schema.org/address

import * as React from 'react';
import PageContentBlock from '../../../../internal/PageContentBlock';
import GoogleMap from '../GoogleMap';
import Address from '../Address';
import styles from './styles.scss';
import type { BusinessNumberType, TelephoneType } from '../types';
import type { AddressType } from '../../../../internal/Address';

export type PropTypes = {|
  address: AddressType,
  telephoneNumber: TelephoneType,
  businessNumber?: BusinessNumberType,
|};

export default (props: PropTypes) => {
  return (
    <PageContentBlock>
      <div>
        <div className={styles.container}>
          <div className={styles.contact}>
            <h2 className={styles.title}>Contact us</h2>
            <Address {...props} className={styles.address} />
          </div>
          <div className={styles.map}>
            <GoogleMap address={props.address} />
          </div>
        </div>
      </div>
    </PageContentBlock>
  );
};
